import {
  fetchTicketAttachments,
  getWorkflowFiveDetails,
  updateDateApprovalAndGatePass,
  updateFileTicketRemovedByMa,
  uploadTicketAttachment,
} from '@/api/maintenance-tickets-api'
import { FC, useEffect, useState } from 'react'
import {
  styled,
  Modal,
  Box,
  Typography,
  Button,
  Divider,
  Grid,
  FormControl,
  Tooltip,
  TextField,
  Snackbar,
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ButtonProps,
} from '@mui/material'
import useSWR from 'swr'
import CloseIcon from '@mui/icons-material/Close'
import PdfIcon from '@/assets/icons/pdf-icon.png'
import { DatePicker } from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { useAlert } from '@/utilities/useAlert'
import { Delete } from '@mui/icons-material'

interface ActionButtonProps extends ButtonProps {
  bgcolor: string
}

const ActionButton = styled(Button)<ActionButtonProps>(({ bgcolor }) => ({
  backgroundColor: bgcolor,
}))

interface ApproveModalProps {
  open: boolean
  onClose: () => void
  onCloseViewTicket: () => void
  onApprove: (ticketId: number, note: string) => void
  data?: any
  isNested?: boolean
  mutate: () => Promise<any>
}

export const ApproveDISWithGatePassModal: FC<ApproveModalProps> = ({
  open,
  onClose,
  onApprove,
  data,
  isNested,
  onCloseViewTicket,
  mutate,
}) => {
  const roleString = localStorage.getItem('role')
  const userRole = roleString ? JSON.parse(roleString) : ''

  const { handleAlertMessage, ...alertRest } = useAlert()

  const getAllDISTicketAttachments = async () => {
    try {
      const response = await fetchTicketAttachments(
        data.id,
        'SIGNED_DIS_QUOTATION',
      )
      return response.data.data
    } catch (error) {
      console.error('Failed to fetch attachments:', error)
      throw error
    }
  }

  const fetchWorkflowFiveDetails = async () => {
    try {
      const response = await getWorkflowFiveDetails(data.id)
      return response.data.data
    } catch (error) {
      console.error('Failed to fetch attachments:', error)
      throw error
    }
  }

  const shouldFetchDISAttachments =
    data?.currentLayerId === 10 &&
    data?.workFlowId === 5 &&
    userRole === 'Maintenance Admin'

  const { data: disAttachments, mutate: mutateDISAttachments } = useSWR(
    shouldFetchDISAttachments ? `/v1/attachment` : null,
    getAllDISTicketAttachments,
    { revalidateOnFocus: false },
  )

  const {
    data: approvalDateAndGatePass,
    mutate: mutateApprovalDateAndGatePass,
  } = useSWR(
    shouldFetchDISAttachments ? `/v1/ticket/details` : null,
    fetchWorkflowFiveDetails,
    { revalidateOnFocus: false },
  )

  const [approvalDate, setApprovalDate] = useState<Dayjs | null>(null)
  const [gatePassNumber, setGatePassNumber] = useState<string>('')

  const handleUploadDIS = async (
    file: File,
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    try {
      await uploadTicketAttachment(data.id, 'SIGNED_DIS_QUOTATION', file)
      mutateDISAttachments()
    } catch (error) {
      console.error('Failed to upload dis attachment:', error)
    } finally {
      e.target.value = ''
    }
  }

  const handleRemoveFile = async (idToRemove: number) => {
    if (!disAttachments) return

    const remainingIds = disAttachments
      .filter((file: any) => file.id !== idToRemove)
      .map((file: any) => file.id)

    try {
      await updateFileTicketRemovedByMa(
        data.id,
        parseFloat(data.amount),
        remainingIds,
      )
      mutateDISAttachments()
    } catch (error) {
      console.error('Failed to remove file:', error)
    }
  }

  const handleSave = async () => {
    if (
      !approvalDate ||
      !disAttachments ||
      disAttachments?.length === 0
    ) {
      handleAlertMessage(
        'Missing approval date or Signed Dealer Attachments.',
        'error',
      )
      return
    }

    const retainAttachmentIds = disAttachments?.map((item: any) => item.id) || [
      0,
    ]

    const payload = {
      ticketId: data.id,
      dateOfApproval: approvalDate.format('YYYY-MM-DD HH:mm:ss'),
      gatePassNumber: gatePassNumber,
      retainAttachmentIds,
      isSubmit: true,
    }

    try {
      await updateDateApprovalAndGatePass(payload)
      mutateApprovalDateAndGatePass()
    } catch (error) {
      handleAlertMessage('Failed to update approval and gate pass.', 'error')
    }
    mutate()
    onClose()
    onCloseViewTicket()
  }

  useEffect(() => {
    if (approvalDateAndGatePass) {
      const { dateOfApproval, gatePassNumber } = approvalDateAndGatePass
      if (dateOfApproval) {
        setApprovalDate(dayjs(dateOfApproval))
      }
      if (gatePassNumber !== null) {
        setGatePassNumber(String(gatePassNumber))
      }
    }
  }, [approvalDateAndGatePass])

  console.log('WORKFLOW 5')

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={!isNested}
      maxWidth={!isNested ? 'sm' : false}
      PaperProps={{
        sx: isNested ? { width: 'auto', maxWidth: 650 } : {},
      }}
    >
      <DialogTitle sx={{ p: 0 }}>
        <Box sx={{ px: '2rem', pt: '1.5rem' }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              sx={{
                fontFamily: 'Gabarito',
                fontWeight: 500,
                fontSize: '22px',
                color: '#505470',
              }}
            >
              Approve Ticket
            </Typography>
            <IconButton
              size="small"
              aria-label="close"
              sx={{
                color: '#505470',
                width: 20,
                height: 20,
              }}
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider sx={{ my: 2, borderWidth: 2, color: '#B1B8BF' }} />
        </Box>
      </DialogTitle>
      <DialogContent sx={{ px: 3, pt: 2 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Typography mb={1}>
                Attached Signed Dealer Investment Summary
                <Typography component="span" color="red" ml={0.5}>
                  *
                </Typography>
              </Typography>
              <Button
                variant="contained"
                component="label"
                sx={{ width: '70%', maxWidth: '40%'}}
              >
                <Typography display="flex" alignItems="center">
                  Attach
                </Typography>
                <input
                  type="file"
                  hidden
                  multiple
                  accept="application/pdf"
                  onChange={(e) => {
                    const files = e.target.files
                    if (files?.length) {
                      const firstFile = files[0]
                      handleUploadDIS(firstFile, e)
                    }
                  }}
                />
              </Button>
            </FormControl>
          </Grid>

          {disAttachments?.length > 0 && (
            <Grid item xs={12}>
              {disAttachments.map((file: any, index: number) => {
                const isFileInstance = file instanceof File
                const fileType = isFileInstance ? file.type : file.fileType
                const fileName = isFileInstance ? file.name : file.fileName
                const fileUrl = isFileInstance
                  ? URL.createObjectURL(file)
                  : file.presignedUrl

                const isImage = fileType?.startsWith('image/')

                return (
                  <Box
                    key={index}
                    display="flex"
                    alignItems="center"
                    gap={1}
                    mt={1}
                  >
                    <img
                      src={isImage ? fileUrl : PdfIcon}
                      alt={fileName}
                      width={25}
                      height={25}
                      style={{ objectFit: 'cover' }}
                    />
                    <Tooltip title={fileName} arrow>
                      <Typography
                        variant="body2"
                        sx={{
                          maxWidth: '120px',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          cursor: 'pointer',
                        }}
                      >
                        <a
                          target="_blank"
                          href={fileUrl}
                          style={{
                            color: '#000',
                            fontWeight: 500,
                          }}
                        >
                          {fileName}
                        </a>
                      </Typography>
                    </Tooltip>
                    <IconButton
                      onClick={() => handleRemoveFile(file.id)}
                      size="small"
                    >
                      <Delete />
                    </IconButton>
                  </Box>
                )
              })}
            </Grid>
          )}
          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Typography sx={{ marginBottom: 1 }}>
                Approval Date
                <Typography component="span" color="red" ml={0.5}>
                  *
                </Typography>
              </Typography>
              <DatePicker
                label="Date of Approval"
                value={approvalDate}
                onChange={(newValue) => setApprovalDate(newValue)}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    variant: 'outlined',
                    margin: 'dense', // Optional: improves spacing
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12}>
            <Typography sx={{ marginBottom: 1 }}>Gate Pass Number</Typography>

            <TextField
              label="Gate Pass Number"
              type="text"
              fullWidth
              value={gatePassNumber}
              InputProps={{
                inputProps: { inputMode: 'numeric' },
                sx: {
                  '& input[type=number]': { MozAppearance: 'textfield' },
                  '& input[type=number]::-webkit-outer-spin-button': {
                    WebkitAppearance: 'none',
                    margin: 0,
                  },
                  '& input[type=number]::-webkit-inner-spin-button': {
                    WebkitAppearance: 'none',
                    margin: 0,
                  },
                },
              }}
              onChange={(e) => setGatePassNumber(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pb: 2,
          display: 'flex',
          flexDirection: { xs: 'column-reverse', sm: 'row' },
          gap: { xs: 2, md: 1 },
          '& > :not(style) ~ :not(style)': {
            marginLeft: 0,
          },
        }}
      >
        {/* <Button
          onClick={handleSave}
          variant="outlined"
          fullWidth
          sx={{ width: { xs: '100%', sm: 'auto' } }}
        >
          Save
        </Button> */}
        <Button
          variant="contained"
          sx={{
            bgcolor: '#379F86',
            color: 'white',
            width: { xs: '100%', sm: 'auto' },
          }}
          onClick={() => {
            data.workFlowId === 5 && data.currentLayerId === 10
              ? handleSave()
              : onApprove(data.id, data.remark ?? '')
          }}
        >
          Approve
        </Button>
      </DialogActions>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={alertRest.showAlert}
        onClose={alertRest.handleCloseAlert}
        autoHideDuration={3000}
      >
        <Alert
          onClose={alertRest.handleCloseAlert}
          elevation={6}
          variant="filled"
          severity={alertRest.alertSeverity}
        >
          {alertRest.alertMessage}
        </Alert>
      </Snackbar>
    </Dialog>
  )
}
